import { Input } from 'antd';
import styled from 'styled-components';

const StyledInput = styled(Input)`
  &.ant-input {
    color: #333;
    border-radius: 2px;
  }
  &.ant-input:hover {
    border-color: #f0b90b;
  }
  &.ant-input:focus {
    border-color: #f0b90b;
    box-shadow: 0 0 0 2px rgba(240, 185, 11, 0.2);
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none !important;
    margin: 0;
  }
  &[type='number'] {
    appearance: textfield;
  }
`;

export default StyledInput;
